import React from 'react'
export default function Dashboard() {
  return (
    <React.Fragment>
      <h1>Hi I'm Dashboard</h1>
    </React.Fragment>
  )
}